import React from 'react';
import { DaySchedule } from './types';
import TimeSlotInput from './TimeSlotInput';

interface DayScheduleRowProps {
  label: string;           // Day name or formatted date
  dayKey: number | string; // Day of week (0-6) or date string
  schedule: DaySchedule;
  onToggle: (key: number | string, enabled: boolean) => void;
  onAddSlot: (key: number | string) => void;
  onRemoveSlot: (key: number | string, slotIndex: number) => void;
  onUpdateSlot: (key: number | string, slotIndex: number, field: 'startTime' | 'endTime', value: string) => void;
}

const DayScheduleRow: React.FC<DayScheduleRowProps> = ({
  label,
  dayKey,
  schedule,
  onToggle,
  onAddSlot,
  onRemoveSlot,
  onUpdateSlot,
}) => {
  const { isEnabled, slots } = schedule;

  return (
    <div className={`py-3 border-b border-gray-100 last:border-b-0 ${!isEnabled ? 'opacity-60' : ''}`}>
      <div className="flex items-start gap-4">
        {/* Checkbox and Day Label */}
        <div className="flex items-center gap-3 min-w-[140px]">
          <input
            type="checkbox"
            checked={isEnabled}
            onChange={(e) => onToggle(dayKey, e.target.checked)}
            className="h-4 w-4 text-[#3A5E63] border-gray-300 rounded focus:ring-[#3A5E63]"
          />
          <span className={`font-medium ${isEnabled ? 'text-gray-800' : 'text-gray-400'}`}>
            {label}
          </span>
        </div>

        {/* Time Slots */}
        <div className="flex-1 flex flex-col gap-2">
          {isEnabled ? (
            slots.length > 0 ? (
              slots.map((slot, index) => (
                <TimeSlotInput
                  key={slot.id || index}
                  slot={slot}
                  index={index}
                  disabled={false}
                  showRemove={slots.length > 1}
                  onUpdate={(idx, field, value) => onUpdateSlot(dayKey, idx, field, value)}
                  onRemove={(idx) => onRemoveSlot(dayKey, idx)}
                />
              ))
            ) : (
              <span className="text-sm text-gray-400 italic py-1">No hours set</span>
            )
          ) : (
            <span className="text-sm text-gray-400 italic py-1">Not working</span>
          )}
        </div>

        {/* Add Slot Button */}
        {isEnabled && (
          <button
            type="button"
            onClick={() => onAddSlot(dayKey)}
            className="p-1 text-gray-400 hover:text-[#3A5E63] hover:bg-gray-100 rounded transition-colors"
            title="Add time slot"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default DayScheduleRow;
